// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login___oqPK","label":"login_label__TLlgY","close":"login_close__z8flM","open":"login_open__QjHfs","popover":"login_popover__imUA_","overlay":"login_overlay__bZcxM"};